'use client';
import React, { Suspense, useRef, useState } from 'react';
import Image from 'next/image';


// Rotating 3D Model component
const RotatingProduct = ({ modelPath }) => {
  const modelRef = useRef();

  // Rotate the model on the y-axis
  useFrame(() => {
    modelRef.current.rotation.y += 0.005; // Adjust the speed of rotation if needed
  });

  // Load the 3D model (GLTF format)
  const { scene } = useGLTF(modelPath); // Load model based on the passed modelPath

  return <primitive object={scene} ref={modelRef} scale={1.5} />;
};

// Main component to render the scene
const Three = () => {
  // List of 3D models
  const models = [
    '/models/sorceress.glb',  // Example model 1
    '/models/axe.glb',        // Example model 2
  ];

  // Content for "Coque section"
  const coqueContent = [
    {
      title: "Coque CLE",
      description: "La coque decorative protège zi,vek,kze,l;glz;eg;g^g^;pzg;^gh;ph;;hpzhh^;h^z ",
    },
    {
      title: "Coque AXE",
      description: "La coque robuste ",
    },
  ];

  const [currentModelIndex, setCurrentModelIndex] = useState(0); // State to track the current model

  // Function to handle left arrow click
  const handlePrevious = () => {
    setCurrentModelIndex((prevIndex) =>
      prevIndex === 0 ? models.length - 1 : prevIndex - 1
    );
  };

  // Function to handle right arrow click
  const handleNext = () => {
    setCurrentModelIndex((prevIndex) =>
      prevIndex === models.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div
      className="relative h-screen bg-cover bg-center flex justify-center items-center"
      style={{ backgroundImage: "url('/icons/bg.png')" }}
    >
      {/* Container for arrows and product */}
      <div className="flex items-center space-x-4">
        {/* Left Arrow */}
        <Image
          src="/icons/arrowleft.png"
          width={25.79}
          height={22.63}
          className="w-[20px] h-[20px] md:w-[25.79px] md:h-[22.63px] cursor-pointer"
          alt="Left Arrow Icon"
          onClick={handlePrevious} // Trigger previous model on click
        />
        {/* Product Div */}
        <div className="p-4 flex justify-center items-center">
          <div className="w-[474px] h-[460px]">
            {/* 3D Canvas for rotating product */}
            <Canvas>
              <Suspense fallback={null}>
                <ambientLight intensity={0.5} />
                <directionalLight position={[2, 2, 5]} />
                <RotatingProduct modelPath={models[currentModelIndex]} />
                <OrbitControls enableZoom={false} />
              </Suspense>
            </Canvas>
          </div>
        </div>
        {/* Right Arrow */}
        <Image
          src="/icons/arrowright.png"
          width={25.79}
          height={22.63}
          className="w-[20px] h-[20px] md:w-[25.79px] md:h-[22.63px] cursor-pointer"
          alt="Right Arrow Icon"
          onClick={handleNext} // Trigger next model on click
        />
      </div>

      {/* Ellipses below the product */}
      <div className="absolute bottom-24 flex justify-center w-full space-x-4">
        {models.map((_, index) => (
          <div
            key={index}
            className={`w-4 h-4 rounded-full ${
              currentModelIndex === index ? 'bg-black' : 'bg-white'
            }`}
          />
        ))}
      </div>

      {/* Bottom left: Découvrez les nouveautés */}
      <div className="absolute bottom-8 left-0 m-4">
        <h1 className="text-white text-[50px] font-bold">
          Découvrez <br /> les nouveautés
        </h1>
      </div>

      {/* Bottom right: Coque section */}
      <div className="absolute bottom-9 right-0 m-4 text-right w-[20%] ">
        <h2 className="text-[#CC0001] text-[50px] ">{coqueContent[currentModelIndex].title}</h2>
        <h3 className="text-black text-[25px] truncate">
          {coqueContent[currentModelIndex].description}
        </h3>
      </div>
    </div>
  );
};

export default Three;
